import Vue from 'vue'
import _ from 'lodash'

let storageHelper = {
  local: {
    get (k) {
      let res = null
      if (window.localStorage) {
        try {
          res = JSON.parse(localStorage.getItem(k))
          if (res['_key_'] !== undefined) res = res['_key_']
        } catch (e) {}
      } else {
        try {
          res = JSON.parse(Vue.Cookie.get(k))
          if (res['_key_'] !== undefined) res = res['_key_']
        } catch (e) {}
      }
      return res
    },
    set (k, v) {
      if (window.localStorage) {
        if (Vue._h.isIphone()) {
          this.remove(k)
        }
        try {
          if (typeof v !== 'object') v = {_key_: v}
          localStorage.setItem(k, JSON.stringify(v))
        } catch (e) {}
      } else {
        try {
          if (typeof v !== 'object') v = {_key_: v}
          Vue.Cookie.set(k, JSON.stringify(v), { expires: 365, path: '/' })
        } catch (e) {}
      }
    },
    remove (k) {
      if (window.localStorage) {
        try {
          localStorage.removeItem(k)
        } catch (e) {}
      } else {
        try {
          Vue.Cookie.remove(k)
        } catch (e) {}
      }
    },
    getColl (collName, key) {
      var coll = this.get(collName) || {}
      return key ? coll[key] : coll
    },
    setColl (collName, keyOrMap, value, isDeep) {
      let coll = this.get(collName) || {}
      if (_.isPlainObject(keyOrMap)) {
        coll = _.extend(coll, keyOrMap)
      } else {
        let map = {}
        map[keyOrMap] = value
        isDeep = typeof isDeep === 'boolean' ? isDeep : _.isPlainObject(value)
        coll = isDeep ? _.merge(coll, map) : _.extend(coll, map)
      }
      this.set(collName, coll)
      return coll
    },
    delColl (collName, key) {
      let coll = this.get(collName) || {}
      delete coll[key]
      this.set(collName, coll)
      return coll
    },
    clearColl (collName) {
      this.remove(collName)
    }
  },
  session: {
    get (k) {
      let res = null
      if (Vue.Cookie.isEnabled) {
        try {
          res = JSON.parse(Vue.Cookie.get(k))
          if (res['_key_'] !== undefined) res = res['_key_']
        } catch (e) {}
      } else {
        try {
          res = JSON.parse(sessionStorage.getItem(k))
          if (res['_key_'] !== undefined) res = res['_key_']
        } catch (e) {}
      }
      return res
    },
    set (k, v, expires) {
      if (Vue.Cookie.isEnabled) {
        try {
          if (typeof v !== 'object') v = {_key_: v}
          Vue.Cookie.set(k, JSON.stringify(v), { expires: expires || '3h', path: '/' })
        } catch (e) {}
      } else {
        try {
          if (typeof v !== 'object') v = {_key_: v}
          sessionStorage.setItem(k, JSON.stringify(v))
        } catch (e) {}
      }
    },
    remove (k) {
      if (Vue.Cookie.isEnabled) {
        try {
          Vue.Cookie.remove(k)
        } catch (e) {}
      } else {
        try {
          localStorage.removeItem(k)
        } catch (e) {}
      }
    },
    getColl (collName, key) {
      var coll = this.get(collName) || {}
      return key ? coll[key] : coll
    },
    setColl (collName, keyOrMap, value, expires, isDeep) {
      let coll = this.get(collName) || {}
      if (_.isPlainObject(keyOrMap)) {
        coll = _.extend(coll, keyOrMap)
      } else {
        let map = {}
        map[keyOrMap] = value
        isDeep = typeof isDeep === 'boolean' ? isDeep : _.isPlainObject(value)
        coll = isDeep ? _.merge(coll, map) : _.extend(coll, map)
      }
      this.set(collName, coll, expires)
      return coll
    },
    delColl (collName, key) {
      let coll = this.get(collName) || {}
      delete coll[key]
      this.set(collName, coll)
      return coll
    },
    clearColl (collName) {
      this.remove(collName)
    }
  }
}

export default storageHelper



// WEBPACK FOOTER //
// ./src/assets/js/helper/storage.js